/**
 * @constant {Object} ApplicationConstants
 * @memberof Application
 */
export const WorkflowConstants = {
  CHECKIN_ACTION: 'CHECKIN_ACTION',
  NEXT_ACTION: 'NEXT_ACTION',
  PREVIOUS_ACTION: 'PREVIOUS_ACTION',
  GET_IP_ADDRESS: 'GET_IP_ADDRESS',
  GET_TEST_VALUES_DATA: 'GET_TEST_VALUES_DATA',
};
